import { graphql, useStaticQuery } from 'gatsby';

const globalSignupLegal = () => {
  const data = useStaticQuery(graphql`
    {
      wordpressAcfOptions {
        options {
          global_signup {
            legal
          }
        }
      }
    }
  `);
  return data.wordpressAcfOptions.options.global_signup.legal as string;
};

export default globalSignupLegal;